import { getDemoData, matchRestRequest } from '../utils'
import { DEMO_COMPANY_ID } from 'api/demo'

export const mockGetWorkerCompliments = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/worker_compliments_6959ef79',
      'POST'
    ),
  getResponse: async (request) => {
    const params = request.data
    const demoData = getDemoData()
    const workerId = Number(params.workerId)

    const allWorkWithReview = demoData.shifts
      .map((shift) =>
        (shift.work ?? []).map((work) => ({
          ...work,
          shift,
        }))
      )
      .flat()
      .filter((work) => work.worker?.id === workerId && work.e2wReview)

    return {
      data: {
        company: {
          id: DEMO_COMPANY_ID,
          name: 'DemoCo',
          worker: {
            workForWorkWhile: allWorkWithReview,
          },
        },
      },
    }
  },
}
